import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
import { WorkspaceItem } from '@primatoo-ms-organization';

@Component({
  selector: 'pt-rename-resource-dialog',
  template: `
    <div class='modal-header'>
      <h4 class='modal-title'>
        {{ "LABELS.RENAME" | translate }}</h4>
    </div>

    <div class='modal-body'>
      <form [formGroup]='formGroup'>
        <div class='form-group'>
          <label class="form-label">{{ 'LABELS.NAME' | translate }}</label>
          <input type='text'
                 autocomplete='off'
                 formControlName='name'
                 class='form-control form-control-sm'
          >
        </div>
      </form>
    </div>

    <div class='modal-footer'>
      <button type='button' class='btn btn-primary btn-sm'
              [disabled]='formGroup?.invalid'
              (click)='confirm(); $event.stopPropagation()'>
        {{ 'BUTTON.CONFIRM' | translate }}
      </button>

      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false); $event.stopPropagation()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>
  `,
  styles: [``]
})
export class RenameResourceDialogComponent implements OnInit {

  @Input() resource: WorkspaceItem;

  public formGroup: FormGroup;

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      name: new FormControl({value: this.resource?.name, disabled: false})
    });
  }

  cleanFolder() {
    this.formGroup?.controls?.folder?.setValue(null);
  }

  confirm() {
    const response = {
      name: this.formGroup.controls.name.value
    } as WorkspaceItem;

    this.activeModal.close(response);
  }
}

